import axios from 'axios';
import './App.css';
import Student from './components/Student/Student';
import {useEffect ,useState} from "react";
import Navbar from './components/Navbar/Navbar';
import Form from './components/Form/Form';

function App() {
 
  const [done,setdone]=useState(true);
  const [data,setdata]=useState([]);
  const [delState,setDelState]=useState(false);
  useEffect(()=>{
    axios.get("https://66ed69c7380821644cdcbca5.mockapi.io/todolist").then((success)=>{
      setdata(success.data);
    }).catch((error)=>{
      console.log(error);
    })
  },[done,delState]);
 
  return (
    <div className="app">
      <Navbar/>
      <Form setdone={setdone} done={done}/>
      <Student mydata={data} setDelState={setDelState} delState={delState}/>
    </div>
  );
}

export default App;
